import { IGlobalPlaceFilter } from '@/models/GlobalPlace/interfaces/IGlobalPlaceFilter';
import { ISessionGetPlaceFiltersPayload } from '@/models/Session/interfaces/ISessionGetPlaceFiltersPayload';
import ISessionSetMemberTransferAgreedPayload from '@/models/Session/interfaces/ISessionSetMemberTransferAgreedPayload';
import ISessionSetMemberTransferAgreedRequestParams from '@/models/Session/interfaces/ISessionSetMemberTransferAgreedRequestParams';
import { ISessionSetSocialLoginConfirmedRequestParams } from '@/models/Session/interfaces/ISessionSetSocialLoginConfirmedRequestParams';
import debug from 'debug';

import { BaseActions } from '../Common/Actions/BaseActions';
import { execAction } from '../Common/Actions/handler';
import { ResponseEither } from '../Common/ResponseEither';
import { ISessionSetGlobalPlaceFiltersRequestParams } from './interfaces/ISessionSetGlobalPlaceFiltersRequestParams';
import { ISessionSetPlaceFiltersRequestParams } from './interfaces/ISessionSetPlaceFiltersRequestParams';
import { SessionRequestBuilder } from './SessionRequestBuilder';

const log = debug('sunny:SessionActions');

export class SessionActions extends BaseActions<SessionRequestBuilder> {
  /**
   * 해외숙소 필터를 세션에 저장.
   */
  setGlobalPlaceFilters(params: ISessionSetGlobalPlaceFiltersRequestParams): Promise<ResponseEither<void>> {
    log('Setting global filters');
    return execAction('set global place filters', this.requestBuilder.createPostSetGlobalPlaceFiltersQuery(params));
  }

  /**
   * 세션에 저장된 해외숙소 필터 정보 조회.
   */
  getGlobalPlaceFilters(): Promise<ResponseEither<IGlobalPlaceFilter>> {
    log('Getting global filters');
    return execAction('get global place filters', this.requestBuilder.createGetGlobalPlaceFiltersQuery());
  }

  /**
   * 국내숙소 필터를 세션에 저장.
   */
  setPlaceFilters(params: ISessionSetPlaceFiltersRequestParams): Promise<ResponseEither<void>> {
    log('Setting filters');
    return execAction('set place filters', this.requestBuilder.createPostSetPlaceFiltersQuery(params));
  }

  /**
   * 세션에 저장된 국내숙소 필터 정보 조회.
   */
  getPlaceFilters(): Promise<ResponseEither<ISessionGetPlaceFiltersPayload>> {
    log('Getting filters');
    return execAction('get place filters', this.requestBuilder.createGetPlaceFiltersQuery());
  }

  setSocialLoginConfirmed(params: ISessionSetSocialLoginConfirmedRequestParams): Promise<ResponseEither<void>> {
    log('Set social login confirmed');
    return execAction('set social login confirmed', this.requestBuilder.createPostSetSocialLoginConfirmedQuery(params));
  }

  /**
   * 회원 전환 동의 여부 저장.
   */
  setMemberTransferAgreed(
    params: ISessionSetMemberTransferAgreedRequestParams,
  ): Promise<ResponseEither<ISessionSetMemberTransferAgreedPayload>> {
    log('Set member transfer agreed');
    return execAction('set member transfer agreed', this.requestBuilder.createPostSetMemberTransferAgreed(params));
  }

  /**
   * 놀카드 연동 여부 확인
   */
  getNolConnected(): Promise<ResponseEither<boolean>> {
    log('Get Nol card connected');
    return execAction('get nol card connected', this.requestBuilder.createGetNolConnected());
  }

  /**
   * 닉네임 툴팁 가이드 노출 여부
   */
  getIsShowNicknameTooltip(): Promise<ResponseEither<boolean>> {
    log('getIsShowNicknameTooltip');
    return execAction('getIsShowNicknameTooltip', this.requestBuilder.createGetIsShowNicknameTooltip());
  }

  /**
   * GNB > 회원 등급 뱃지 노출 여부
   */
  getIsShowMembershipBadge(): Promise<ResponseEither<boolean>> {
    log('getIsShowMembershipBadge');
    return execAction('getIsShowMembershipBadge', this.requestBuilder.createGetIsShowMembershipBadge());
  }
}
